import { MutationTree } from 'vuex';
import { IEntityState } from './entity.types';
import { EEntityMutation } from './entity.constants';
import { IUser } from '@/types/User';
import { IEntity } from '@/entity/types/entity';
import { ITeam } from '@/types/Team';
import { IPlanStatus } from '@/types/plan-status';
import { ISelectEntity } from '@lib-shared/types/select-entity';

export const mutations: MutationTree<IEntityState> = {
  [EEntityMutation.SetIsLoading](state: IEntityState, payload: boolean) {
    state.isLoading = payload;
  },
  [EEntityMutation.SetEntitySettings](state: IEntityState, payload: IEntity) {
    state.entityId = payload.entityId;
  },
  [EEntityMutation.SetUsers](state: IEntityState, payload: IUser[]) {
    state.users = payload;
  },
  [EEntityMutation.SetTeams](state: IEntityState, payload: ITeam[]) {
    state.teams = payload;
  },
  [EEntityMutation.SetIsLoadingTeams](state: IEntityState, payload: boolean) {
    state.isLoadingTeams = payload;
  },
  [EEntityMutation.SetEntity](state: IEntityState, payload: IEntity) {
    state.entity = payload;
  },
  [EEntityMutation.SetPlanStatus](state: IEntityState, payload: IPlanStatus) {
    state.planStatus = payload;
  },
  [EEntityMutation.SetEntities](state: IEntityState, entities: ISelectEntity[]) {
    state.entities = entities;
  },
};
